import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOPerfilAssistencia from '../../ModulosCrefito/ModulosTO/TOPerfilAssistencia'
import TOrecursos from '../../ModulosCrefito/ModulosTO/TOrecursos'
import TOregistroProntuario from '../../ModulosCrefito/ModulosTO/TOregistroProntuario'
import TOestagio from '../../ModulosCrefito/ModulosTO/TOestagio'
import TOpessoaNaoHabilitada from '../../ModulosCrefito/ModulosTO/TOpessoaNaoHabilitada'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import TOparametrosAssistenciais from '../../ModulosCrefito/ModulosTO/TOparametrosAssistenciais'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Consultorio = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="PERFIL DA ASSISTÊNCIA DE TERAPIA OCUPACIONAL" modulo="toperfilassistencia" />
            <TOPerfilAssistencia modulo="toperfilassistencia" />
            <QtdModulo texto="RECURSOS TERAPÊUTICOS / AMBIENTES DO SERVIÇO" modulo="torecursos" />
            <TOrecursos modulo="torecursos" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="toparametrosassistenciais" />
            <TOparametrosAssistenciais modulo="toparametrosassistenciais" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="toregistroprontuario" />
            <TOregistroProntuario modulo="toregistroprontuario" />
            <QtdModulo texto="ESTÁGIO" modulo="toestagio" />
            <TOestagio modulo="toestagio" />
            <QtdModulo texto="PESSOA NÃO HABILITADA A EXERCER ATIVIDADES PRIVATIVAS DA TO" modulo="topessoanaohabilitada" />
            <TOpessoaNaoHabilitada modulo="topessoanaohabilitada" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
        </>
    )
}

export default Consultorio